import { render, staticRenderFns } from "./QRcode.vue?vue&type=template&id=6397ebee&scoped=true"
import script from "./QRcode.vue?vue&type=script&lang=js"
export * from "./QRcode.vue?vue&type=script&lang=js"
import style0 from "./QRcode.vue?vue&type=style&index=0&id=6397ebee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6397ebee",
  null
  
)

export default component.exports